<template>
  <div class="content widfix">
    <form
      id="scReq"
    >
      <div id="sc-req-realgrid" style="width: 1205px; height: 400px"></div>
      <div id="layerPop">
        <win-layer-pop class="sc-pre-req-pop">
          <component
            v-if="customComponent"
            :is="customComponent"
            @close="closePopup"
            :parent-info="popupParams"
          />
        </win-layer-pop>
      </div>

      <div class="sr-preview-upload-pop">
        <win-layer-pop>
          <component
            v-if="scPreUploadComponent"
            :is="scPreUploadComponent"
            @close="closeScPreUploadPopup"
            :parent-info="scPreUploadParam"
            @selectFunc="selectFunc"
          />
        </win-layer-pop>
      </div>
    </form>

    <!-- [S] paging -->
    <div
      v-if="rstList.length > 0"
      class="paging"
    >
      <!-- <a
        class="btn start"
        @click.prevent="search(1, false)"
      >Start</a> -->
      <a
        class="btn prev"
        @click.prevent="search(pagination.prevPage, false)"
      >Prev</a>
      <a
        v-for="idx in pageNumberRange"
        :key="idx"
        :class="[idx === params.curPage ? 'on' : '']"
        href="#"
        @click.prevent="search(idx, false)"
      >{{ idx }}</a>
      <a
        class="btn next"
        @click.prevent="search(pagination.nextPage, false)"
      >Next</a>
      <!-- <a
        class="btn end"
        @click.prevent="search(pagination.pageCnt, false)"
      >End</a> -->
    </div>
    <!-- [E] paging -->
  </div>
</template>

<script>
import { createGrid } from '@/plugins/realgridUtil' // realgrid Component
import member from '@/api/rest/user/member'
import ESearchAddress from '@/components/common/ESearchAddress'
import WinLayerPop from '@/pages/trans/popup/WinLayerPop'
import MyInfoPasswordPop from '@/pages/user/popup/MyInfoPasswordPop'
import MyInfoPersonalAgreePop from '@/pages/user/popup/MyInfoPersonalAgreePop'
import MyInfoPersonalAgreeChoicePop from '@/pages/user/popup/MyInfoPersonalAgreeChoicePop'
import MyInfoMarketingAgree from '@/pages/user/popup/MyInfoMarketingAgree'
import DownloadPop from '@/pages/trans/popup/SpecialRfDgDownloadPop'
import DEXT5Upload from '@/components/DEXT5Upload'
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import api from '@/api/services/auth'
import EDatePicker from '@/components/common/EDatePickerCustom'
import EInputNumber from '@/components/common/EInputNumber'
import JSZip from 'jszip' // 엑셀 다운로드용 JSZip Component
import schedule from '@/api/rest/schedule/schedule'
import { rootComputed, rootMethods } from '@/store/helpers'

let gridView = null
let provider = null

export const fields = [
  { fieldName: 'num', dataType: 'text' },
  { fieldName: 'scNo', dataType: 'text' },
  { fieldName: 'amndNo', dataType: 'text' },
  { fieldName: 'strDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' },
  { fieldName: 'endDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' },
  { fieldName: 'fmcOrgEnm', dataType: 'text' },
  { fieldName: 'stsCd', dataType: 'text' },
  { fieldName: 'preview', dataType: 'text' },
  { fieldName: 'attach', dataType: 'text' },
  { fieldName: 'complete', dataType: 'text' },
  { fieldName: 'scReqDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' }

]

export const columns = [
  { name: 'num', fieldName: 'num', type: 'text', header: 'No.', editable: false, width: 20 },
  { name: 'scNo', fieldName: 'scNo', type: 'text', header: 'S/C No.', editable: false, width: 50 },
  { name: 'amndNo', fieldName: 'amndNo', type: 'text', header: 'Amendment', editable: false, datetimeFormat: 'yyyy.MM.dd', width: 50 },
  { name: 'strDt', fieldName: 'strDt', type: 'text', header: 'Start Date', editable: false, datetimeFormat: 'yyyy.MM.dd', width: 50 },
  { name: 'endDt', fieldName: 'endDt', type: 'text', header: 'End Date', editable: false, datetimeFormat: 'yyyy.MM.dd', width: 50 },
  { name: 'fmcOrgEnm', fieldName: 'fmcOrgEnm', type: 'text', header: 'Shipper Name', editable: false, width: 50 },
  { name: 'stsCd', fieldName: 'stsCd', type: 'text', header: 'stsCd', editable: false, width: 50 },
  {
    name: 'scReqDt',
    fieldName: 'scReqDt',
    type: 'text',
    header: 'Request Date',
    editable: false,
    width: 50,
    datetimeFormat: 'yyyy.MM.dd',
    renderer: {}
  },
  {
    name: 'preview',
    fieldName: 'preview',
    type: 'text',
    header: '',
    editable: false,
    width: 50,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const html = []
        const scNo = vmAppScReq.rstList[idx].scNo || ''
        const amndNo = vmAppScReq.rstList[idx].amndNo || ''

        html.push(`<button class="button blue sh" onclick="vmAppScReq.scPreviewPopCall('${scNo}', '${amndNo}')">Preview</button>`) //

        return html
      }
    }
  },
  {
    name: 'attach',
    fieldName: 'attach',
    type: 'text',
    header: 'Attached File',
    editable: false,
    width: 100,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const html = []
        const scNo = vmAppScReq.rstList[idx].scNo || ''
        const amndNo = vmAppScReq.rstList[idx].amndNo || ''
        const fileNm = vmAppScReq.rstList[idx].fileNm || ''

        // html.push(`<input type="text" value="${fileNm}" disabled></input>`)
        html.push(`<input type="text" value="${fileNm}" disabled></input><a onclick="vmAppScReq.scPreviewUploadPopup('${scNo}', '${amndNo}')" class="button sm ml2">FILE</a>`)

        return html
      }
    }
  },
  {
    name: 'complete',
    fieldName: 'complete',
    type: 'text',
    header: 'Complete',
    editable: false,
    width: 50,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const html = []
        const scNo = vmAppScReq.rstList[idx].scNo || ''
        const amndNo = vmAppScReq.rstList[idx].amndNo || ''
        const fileNm = vmAppScReq.rstList[idx].fileNm || ''
        const scPreviewCompYn = vmAppScReq.rstList[idx].scPreviewCompYn || ''

        console.log('scPreviewCompYn @@@@ ', scPreviewCompYn)

        if (scPreviewCompYn === 'Y') {
          html.push(`<a class="button blue sh disabled" onclick="vmAppScReq.scPreviewComplete('${idx}','${scNo}', '${amndNo}')">Complete</a>`)
        } else {
          html.push(`<a class="button blue sh" onclick="vmAppScReq.scPreviewComplete('${idx}','${scNo}', '${amndNo}')">Complete</a>`)
        }

        return html
      }
    }
  }
]

const gridLayout = [
  'num',
  'scNo',
  'amndNo',
  'fmcOrgEnm',
  'scReqDt',
  'preview',
  'attach',
  'complete'
]

export default ({
  name: 'MyScInfoRequest',
  components: {
    WinLayerPop,
    ESearchAddress,
    DownloadPop,
    DEXT5Upload,
    EBreadcrumbs,
    MyInfoDextUploader: () => import('@/pages/user/MyInfoDextUploader'),
    EDatePicker,
    EInputNumber,
    EDateRangePickerSimple: () => import('@/components/common/EDateRangePickerSimple'),
    'e-auto-complete-place': () => import('@/components/common/EAutoCompletePlace'),
    'sc-preview-pop': () => import('@/pages/schedule/popup/ScPreviewPop'),
    'sr-preview-upload-pop': () => import('@/pages/schedule/popup/ScPreviewUploadPop')
  },
  data () {
    return {
      uploadParam: [],
      selectFunc: null,
      showHelp: false,
      ctrList: [],
      userInfoList: [],

      params:
        {
          curPage: 1, // 현재 페이지
          pageSize: 10, // 한 페이지당 게시글 수
          uploadEtcFileInfos: []
        },

        fileList: [],
        // 카테고리가 있는 경우
        catList: [],
        fileOriginalName: '',
        mdtyPsnlInfCltnCnst: '',
        choPsnlInfCltnCnst: '',
        recvCnst: '',

        customComponent: null,
        uploadParams: [],
        uploadFileInfo: [],
        dext5Idx: 0,
        isShowDext5: true,
        isShowDext5Pop: false,

        // 다국어 항목 변수
        isKor: true,

        // 영문입력 체크 변수
        valid: '',
        rstList: [],
        gridList: [],
        currentPage: '',
        totalPage: '',
        total: '',

        etcUploadCallbackFunc: null,
        scPreUploadParam: {},
        scPreUploadType: '',
        scPreUploadComponent: null,
        scPreDeleteAllYn: 'N',
        dgCargoYn: 'N',
        uploadFileList: [],

        popupComponent: null,
        popupParams: {
            items: []
        },
        popupCallback: '',
        pagination: {},
        isInit: false,
        scPreviewSuccYn: 'N'
    }
  },
  computed: {
    ...rootComputed,
    pageNumberRange: function () {
        return [...Array(this.pagination.pageNumberSize).keys()].map(i => i + this.pagination.startPage)
    }
  },
  async mounted () {
    console.log('mounted!')

    window.vmAppScReq = this

    //엑셀 다운로드용 JSZip 셋팅
    window.JSZip = window.JSZip || JSZip

    const grid = createGrid('sc-req-realgrid', {
      fields,
      columns,
      layout: gridLayout,
      header: {
        heights: [40]
      },
      displayOptions: {
        rowHeight: 34,
        fitStyle: 'evenFill',
        selectionStyle: 'block',
        syncGridHeight: true
      },
      stateBar: {
        visible: false
      },
      rowIndicator: {
        visible: false
      },
      checkBar: {
        visible: false
      }
    })
    gridView = grid.gridView
    provider = grid.provider
  },
  created () {
    // 다국어 항목 제어
    if (this.$i18n.locale !== 'ko-KR') {
      this.isKor = false
    }

    this.params = this.parentInfo

    console.log('this.loginInfo ::: === ', this.loginInfo)
  },
  methods: {
    //초기화
    searchInit () {
      this.rstList = []
      provider.setRows(this.rstList)
      this.totalCount = 0
    },
    async search (index, searchFlag, params) {
      if (this.isInit && index < 1) {
        this.$ekmtcCommon.alertDefault(this.$t('js.common.002')) // 처음페이지입니다.
        return
      }
      if (this.isInit && this.pagination && index > this.pagination.pageCnt) {
        this.$ekmtcCommon.alertDefault(this.$t('js.common.001')) // 마지막페이지입니다.
        return
      }

      // !searchFlag(페이지 이동 시) 현재 페이지와 이동할 페이지 같다면
      if (!searchFlag && this.isInit && this.params.curPage === index) return

      if (this.$ekmtcCommon.isEmpty(params)) {
        this.params.curPage = index
      } else {
        params.curPage = index
        this.params = params
      }

      await schedule.getScPreviewList(this.params)
      .then(response => {
          const resp = response.data
          const scPreviewList = resp.scPreviewList
          const pagination = resp.pagination

          console.log('response @@@@ ', response)

          this.rstList = []

          if (scPreviewList.length > 0) {
            this.pagination = pagination
            this.rstList = scPreviewList
          } else {
            this.rstList = []
          }

          provider.setRows(this.rstList)

          if (!this.isInit) this.isInit = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    scPreviewPopCall (scNo, amndNo) {
      const params = {
        scNo, amndNo
      }

      let arrParams = []

      arrParams.push(params)

      this.openPopup('sc-preview-pop', arrParams)
    },
    openPopup (compNm, params) {
      this.popupParams.items = params
      this.customComponent = compNm
      this.$ekmtcCommon.layerOpen('.sc-pre-req-pop')
    },
    closePopup () {
      this.customComponent = null
      this.popupCallback = ''
      this.$ekmtcCommon.layerClose('.sc-pre-req-pop')
    },
    scPreviewUploadPopup (scNo, amndNo) {
      this.scPreUploadParam = {
        taskCatCd: 'B',
        type: 'E',
        scNo: scNo !== undefined ? scNo : '',
        amndNo: amndNo !== undefined ? amndNo : ''
      }

      this.selectFunc = this.uploadComplete
      this.openScPreUploadPopup('sr-preview-upload-pop')
    },
    uploadComplete (returnVo) {
      console.log('uploadComplete @@@@@ ', returnVo)

      if (returnVo.uploadEtcFileInfos.length > 0) {
          this.scPreDeleteAllYn = 'Y'
          this.params.uploadEtcFileInfos = returnVo.uploadEtcFileInfos
      } else {
        this.scPreDeleteAllYn = 'N'
      }

      const param = {
        scNo: returnVo.uploadEtcFileInfos[0].scNo,
        amndNo: returnVo.uploadEtcFileInfos[0].amndNo
      }

      this.closeScPreUploadPopup()
    },
    openScPreUploadPopup (type) {
      const THIS = this
      this.scPreUploadType = type

      this.scPreUploadComponent = 'sr-preview-upload-pop'
      this.$ekmtcCommon.layerOpen('.sr-preview-upload-pop .popup_dim')
    },
    closeScPreUploadPopup () {
      this.search(1, true, this.params)

      this.scPreUploadCallbackFunc = null
      this.scPreUploadComponent = null
      this.$ekmtcCommon.layerClose('.sr-preview-upload-pop .popup_dim')
    },
    scPreviewComplete (idx, scNo, amndNo) {
      const TH = this

      const params = {
        scNo, amndNo
      }
      // this.params.scNo = scNo
      // this.params.amndNo = amndNo
      const fileNm = this.rstList[idx].fileNm || ''

      if (this.$ekmtcCommon.isEmpty(this.params.uploadEtcFileInfos) || this.$ekmtcCommon.isEmpty(fileNm)) {
        this.$ekmtcCommon.alertDefault(this.$t('sc_preview.002'))
        return
      }

      if (scNo !== '' && amndNo !== '') {
        this.$ekmtcCommon.alertCallback(this.$t('sc_preview.001'), function () {
        // sc Preview 요청
        schedule.scPreviewComplete(params).then(response => {
          console.log('scPreviewComplete @@@@ ', response)

          let result = response.data

          if (result.resultCode === 'SUCC') {
            TH.$set(TH.rstList[idx], 'scPreviewCompYn', 'Y')
          } else {
            TH.$set(TH.rstList[idx], 'scPreviewCompYn', 'N')
          }

          provider.setRows(TH.rstList)

          // TH.search(1, true, TH.params)
        })
      })
      } else {
        this.$ekmtcCommon.alertDefault(this.$t('sc_preview.002'))
      }
    }
  }
})
</script>
<style scoped>
.popup_dim .layer_close {z-index: 2998 !important}
.popup_dim2 {z-index: 2999 !important}

.border-none {
  border : 0 !important;
}

table th, td {
    border : 0 !important;
    background: white;
}

table th, td {
    padding: 8px 0 0 10px !important;
    border : 0 !important;
    background: white;
}

.bul_list_sm li::before {
  content: none !important;
}

.input_calendar.mid, .input_calendar.mid input {
    width: 160px !important;
}

.tbl_icon.help {
    margin-bottom: 10px !important;
}

</style>
